import {
    Disclosure,
    DisclosureButton,
    DisclosurePanel,
} from '@reach/disclosure';
import { useProjectAccessStatus } from 'modules/auth';
import { getCollectionsForCurrentProject } from 'modules/data';
import { SingleValueWithForm } from 'modules/forms';
import { useI18n } from 'modules/i18n';
import { useProject } from 'modules/routes';
import { sanitizeHtml } from 'modules/utils';
import PropTypes from 'prop-types';
import { FaInfo } from 'react-icons/fa';
import { useSelector } from 'react-redux';

import CatalogLink from './CatalogLink';

export default function InterviewCollectionInfo({ interview }) {
    const { locale, t } = useI18n();
    const { project } = useProject();
    const collections = useSelector(getCollectionsForCurrentProject);
    const { projectAccessGranted } = useProjectAccessStatus(project);

    const collection = collections?.[interview.collection_id];
    const titleText = t('modules.interview_metadata.show_collection_desc');

    if (collection?.workflow_state === 'unshared') return null;

    return (
        <SingleValueWithForm
            elementType="select"
            obj={interview}
            values={collections}
            withEmpty={true}
            //validate={function(v){return /^\d+$/.test(v)}}
            individualErrorMsg="empty"
            attribute="collection_id"
            value={collection?.name[locale]}
            projectAccessGranted={projectAccessGranted}
            hideEmpty
        >
            {collection && (
                <Disclosure>
                    <DisclosureButton className="Button">
                        <FaInfo title={titleText} aria-label={titleText} />
                    </DisclosureButton>
                    <CatalogLink type="collection" id={collection.id} />
                    <DisclosurePanel>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: sanitizeHtml(
                                    collection.notes[locale],
                                    'RICH_TEXT'
                                ),
                            }}
                        />
                    </DisclosurePanel>
                </Disclosure>
            )}
        </SingleValueWithForm>
    );
}

InterviewCollectionInfo.propTypes = {
    interview: PropTypes.object.isRequired,
};
